export default {
  getAllDiscountRates: state => state.discountRates || [],
};
